import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import HomeView from "@/views/home-view.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/about-view.vue"),
  },
  {
    path: "/listings",
    name: "listings",
    component: () =>
      import(/* webpackChunkName: "listings" */ "@/views/listings-view.vue"),
  },
  {
    path: "/listing/:id",
    name: "listing",
    component: () =>
      import(/* webpackChunkName: "listing" */ "@/views/listing-view.vue"),
  },
  {
    path: "/checkout",
    name: "checkout",
    component: () =>
      import(/* webpackChunkName: "checkout" */ "@/views/checkout-view.vue"),
  },
  {
    path: "/map",
    name: "map",
    component: () =>
      import(/* webpackChunkName: "map" */ "@/views/site-map.vue"),
  },
  {
    path: "/success",
    name: "success",
    component: () =>
      import(/* webpackChunkName: "success" */ "@/views/success-view.vue"),
  },
  {
    path: "/cancel",
    name: "cancel",
    component: () =>
      import(/* webpackChunkName: "success" */ "@/views/cancel-view.vue"),
  },
  {
    path: "/inquiry-success",
    name: "inquiry-success",
    component: () =>
      import(
        /* webpackChunkName: "inquiry-success" */ "@/views/inquiry-success-view.vue"
      ),
  },
  {
    path: "/search-widget",
    name: "search-widget",
    component: () =>
      import(
        /* webpackChunkName: "search-widget" */ "@/views/search-widget-view.vue"
      ),
  },
  {
    path: "/privacy",
    name: "privacy",
    component: () =>
      import(/* webpackChunkName: "privacy" */ "@/views/privacy-view.vue"),
  },
  {
    path: "/terms",
    name: "terms",
    component: () =>
      import(/* webpackChunkName: "terms" */ "@/views/terms-view.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () =>
      import(/* webpackChunkName: "contact" */ "@/views/contact-view.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
